'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'fire';
var width = 448;
var height = 512;
var aliases = [128293];
var unicode = 'f06d';
var svgPathData = 'M187.4-30.1l-10.5-10.2-11.1 9.6C155.2-21.6 145.1-12.4 135.1-2.1 120.2 13.2 100.3 35.3 80.5 63 41.1 118 0 196.9 0 288 0 411.7 100.3 512 224 512S448 411.7 448 288c0-70.3-28.4-132.7-55.6-176.6-13.7-22.1-27.4-40-37.7-52.4-7.2-8.6-15.3-17.2-23.3-25.4L320 21.9 308.6 33.5c-7.8 7.9-15.4 15.9-22.7 24.7-4.2 5-9 11-14.2 17.9-15.7-25.9-31.8-47.6-45.3-64.2-12.4-15.1-25.3-28.7-39-42zM158 20.2c5.7-5.9 11.5-11.4 17.6-16.9 9.1 9.3 17.7 18.7 26 28.9 12.8 15.6 28 36.1 42.7 60.5 8.2 13.5 16.3 27 24.5 40.5 9.5-12.6 19-25.2 28.5-37.8 4.8-6.4 9.3-12 13.2-16.6 3.1-3.7 6.2-7.3 9.5-10.8 3.6 3.9 7 7.7 10.1 11.5 9.6 11.5 22.3 28.2 35.1 48.9 25.6 41.4 50.8 97.9 50.8 159.8 0 106-86 192-192 192S32 394 32 288c0-81.6 37-154 74.5-206.3 18.7-26.1 37.4-47 51.5-61.5l0 0zm19.8 149.5c-.8 .7-1.7 1.3-2.5 2-7.3 5.6-14.3 11.1-21 17.5-6.4 6.1-14.9 14.9-23.4 25.9-16.8 21.8-34.9 53.9-34.9 91.8 0 38.5 14.3 70.2 38.4 92.1 23.9 21.8 56.4 33.1 91.3 33.1 28.5 0 54.4-8.2 78-23.9 49.4-34.5 61.7-102.4 33.1-154.9-2.7-5.4-6.1-12.2-11.2-19l-12-15.9-50.8 59.1-29.4-37.4c-21-26.7-42.9-54.5-45.7-58l-9.9-12.3zm-21.5 64.9c6-7.8 12-14.3 17-19.2 25.3 32 50.5 64.1 75.7 96.2 4.3 5.4 8.5 10.8 12.8 16.2l48.5-56.4c19.6 39.2 9.1 86.8-24.7 110.4-18.5 12.2-37.8 18.2-59.8 18.2-28.2 0-52.6-9-69.8-24.7-17-15.5-28-38.4-28-68.5 0-27.7 13.5-53 28.3-72.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;